import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import it from './locales/it.json';
import en from './locales/en.json';

const resources = {
  it: {
    translation: it
  },
  en: {
    translation: en
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'it', // Default language is Italian
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n;
